export const streamers = [
  "davidp",
  "solary",
  "ogaminglol",
  "ogamingsc2",
  "valorantesports2",
];
